import { setGameHole } from './ggGamesData.js'
// Team Cup CTH — shown only on par 3s; tap the closest-to-pin player.
// Writes ggGames/{id}/cth/{hole} = { playerId } (null = none / carry).
export default function GCthHoleInputs({ gameId, game, hole }) {
  const pars = game.meta?.course?.pars || []
  if ((pars[hole - 1] ?? 4) !== 3) return null
  const players = game.players || []
  const cur = game.cth?.[hole]?.playerId ?? null
  const pick = (pid) => setGameHole(gameId, 'cth', hole, { playerId: cur === pid ? null : pid })
  return (
    <div style={{ border: '1px solid #E5E7EB', borderRadius: 12, padding: 10, marginBottom: 10, background: '#FBFBF7' }}>
      <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 4 }}>🎯 Closest to the pin <span style={{ color: '#888', fontWeight: 400 }}>· par 3</span></div>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {players.map((p) => { const on = cur === p.id; return <button key={p.id} onClick={() => pick(p.id)} style={{ padding: '5px 12px', borderRadius: 999, fontSize: 13, fontWeight: 700, cursor: 'pointer', border: `1px solid ${on ? '#1B7A3E' : '#ccc'}`, background: on ? '#1B7A3E' : '#fff', color: on ? '#fff' : '#333' }}>{p.name.split(' ')[0]}</button> })}
      </div>
    </div>
  )
}
